'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-material-drop',
    cnLight = "".concat(CLASSNAME, "--light"),
    cnRipple = "".concat(CLASSNAME, "__ripple");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function MaterialDrop(_ref) {
  var color = _ref.color,
      disabled = _ref.disabled,
      light = _ref.light;

  var _useState = React.useState([]),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      elements = _useState2[0],
      setElements = _useState2[1];

  React.useEffect(function () {
    return function () {
      elements.forEach(function (el) {
        return window.clearTimeout(el.timeout);
      });
    };
  }, [elements]);

  function start(_ref2) {
    var _ref2$touches = _ref2.touches,
        touches = _ref2$touches === void 0 ? [{}] : _ref2$touches,
        clientX = _ref2.clientX,
        clientY = _ref2.clientY,
        target = _ref2.target,
        timeStamp = _ref2.timeStamp;

    if (disabled) {
      return;
    }

    var rect = target.getBoundingClientRect(),
        x = (touches[0].clientX || clientX) - rect.left,
        y = (touches[0].clientY || clientY) - rect.top;
    var newElements = [].concat(_rollupPluginBabelHelpers.toConsumableArray(elements), [{
      id: timeStamp,
      x: x,
      y: y,
      // fallback
      // NOTE onAnimationEnd is not triggered if element is hidden
      timeout: window.setTimeout(function () {
        _onAnimationEnd(timeStamp);
      }, 1000)
    }]);
    setElements(newElements);
  }

  function _onAnimationEnd(id) {
    var index = elements.findIndex(function (a) {
      return a.id === id;
    });

    if (index > -1) {
      window.clearTimeout(elements[index].timeout);
      var newElements = elements.splice(index, 1);
      setElements(newElements);
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, _rollupPluginBabelHelpers.defineProperty({}, cnLight, light)),
    onMouseDown: start
  }, elements.map(function (_ref3) {
    var id = _ref3.id,
        x = _ref3.x,
        y = _ref3.y;
    var style = {
      backgroundColor: color,
      left: x,
      top: y
    };
    return /*#__PURE__*/React__default.createElement("div", {
      key: id,
      style: style,
      className: cnRipple,
      onAnimationEnd: function onAnimationEnd() {
        _onAnimationEnd(id);
      }
    });
  }));
}
MaterialDrop.propTypes = {
  /** */
  color: PropTypes.string,

  /** */
  disabled: PropTypes.bool,

  /** */
  light: PropTypes.bool
};

module.exports = MaterialDrop;
